import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { AppService } from 'src/app/services/app.service';
import { Registration } from '../../interfaces/userRegistration.interface';


@Component({
  selector: 'app-register-page',
  templateUrl: './register-page.component.html',
  styleUrls: ['./register-page.component.scss']
})
export class RegisterPageComponent {
  private acceptAGB = false;
  private acceptDSGVO = false;

  private registration: Registration = {
    user: {
      email: '',
      family_name: null,
      given_name: null,
      salut: null,
      newsletterOptIn: false,
      industrySector: null
    },
    voidActivation: false,
  };

  public formSubmit = false;

  public emailFormControl = new FormControl(this.registration.user.email, [
    Validators.required,
    Validators.email,
  ]);

  public familyNameFormControl = new FormControl(this.registration.user.family_name, [
    Validators.required,
  ]);

  public industrySectorFormControl = new FormControl(this.registration.user.industrySector, [
    Validators.required,
  ]);

  public givenNameFormControl = new FormControl(this.registration.user.given_name, [
    Validators.required,
  ]);

  public salutFormControl = new FormControl(this.registration.user.salut, [
    Validators.required,
  ]);

  public checkAGBFormControl = new FormControl(this.acceptAGB, []);

  public checkDSGVOFormControl = new FormControl(this.acceptDSGVO, []);

  public checkNewsletterFormControl = new FormControl(this.registration.user.newsletterOptIn, []);

  constructor(private app: AppService) {
    if(this.app.invitationMd5) {
      this.registration.md5 = this.app.invitationMd5;
    }
  }

  public onSubmit(): void {
    this.formSubmit = true;
    this.registration.user.email = this.emailFormControl.value.trim().toLowerCase();
    this.emailFormControl.updateValueAndValidity();
    this.registration.user.family_name = this.familyNameFormControl.value;
    this.familyNameFormControl.updateValueAndValidity();
    this.registration.user.given_name = this.givenNameFormControl.value;
    this.givenNameFormControl.updateValueAndValidity();
    this.registration.user.salut = this.salutFormControl.value;
    this.salutFormControl.updateValueAndValidity();
    this.registration.user.newsletterOptIn = this.checkNewsletterFormControl.value;
    this.checkNewsletterFormControl.updateValueAndValidity();
    this.registration.user.industrySector = this.industrySectorFormControl.value;

    this.checkAGBFormControl.setValidators([
      (c: AbstractControl) => {
        if (this.acceptAGB) {
          return null;
        } else {
          return {
            checked: {
              valid: false
            }
          };
        }
      }
    ]);

    this.checkDSGVOFormControl.setValidators([
      (c: AbstractControl) => {
        if (this.acceptDSGVO) {
          return null;
        } else {
          return {
            checked: {
              valid: false
            }
          };
        }
      }
    ]);

    this.acceptAGB = this.checkAGBFormControl.value;
    this.checkAGBFormControl.updateValueAndValidity();
    this.acceptDSGVO = this.checkDSGVOFormControl.value;
    this.checkDSGVOFormControl.updateValueAndValidity();

    if (
      !this.familyNameFormControl.errors &&
      !this.emailFormControl.errors &&
      !this.salutFormControl.errors &&
      !this.givenNameFormControl.errors &&
      !this.checkAGBFormControl.errors &&
      !this.checkDSGVOFormControl.errors &&
      !this.industrySectorFormControl.errors) {
      this.register();
    }
  }

  protected register(): void {
    this.app.dialog.loader({title: 'Registriere Nutzer'});
    this.registration.user.name = ([
      this.registration.user.given_name,
      this.registration.user.middle_name,
      this.registration.user.family_name]).join(' ');
    this.app.register(this.registration).then((user) => {
      this.registration.user = user;

      setTimeout(() => {
        this.app.dialog.closeLoader();
        this.app.router.navigateByUrl('registrieren/erfolgreich', {
          params: {
            type: 'register',
            email: this.registration.user.email
          }
        });
      });

    }).catch((e: HttpErrorResponse) => {
      this.app.dialog.closeLoader();
      if (e.status === 409) {
        this.app.toast.open('Sie sind bereits registriert, bitte melden Sie sich an.', null, {
          panelClass: 'warn'
        });
      } else {
        this.app.toast.open('Unbekannter Fehler', null, {
          panelClass: 'warn'
        });
      }

    });
  }
}
